exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_object-pie.js
// module id = 109
// module chunks = 42